module.exports = __webpack_public_path__ + "site-81.jpg?1c750f7fd90d3a260a261eb5bd6c8608";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-81.jpg
 ** module id = 193
 ** module chunks = 0
 **/